import type { ReactElement, ReactNode } from 'react';
import React, { useState } from 'react';
import clsx from 'clsx';
import { uniqueId } from 'lodash';

export type Props = {
  label: ReactNode;
  value: boolean;
  onChange(value: boolean): void;
  className?: string;
  isDisabled?: boolean;
};

/**
 * A Basic toggle input

 * Use Cases:
 *
 * - toggle reference data
 * - hide part of a report
 * - etc
 */
export function Toggle({ label, value, onChange, isDisabled, className }: Props): ReactElement {
  const [id] = useState(() => uniqueId('toggle-'));
  return (
    <div className={clsx('form-check form-switch', className)}>
      <input
        type="checkbox"
        className="form-check-input"
        id={id}
        checked={value}
        onChange={(): void => onChange(!value)}
        disabled={isDisabled}
      />
      <label className="form-check-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
}
